import { render, staticRenderFns } from "./signle.vue?vue&type=template&id=9cdf578a&scoped=true&"
import script from "./signle.vue?vue&type=script&lang=js&"
export * from "./signle.vue?vue&type=script&lang=js&"
import style0 from "./signle.vue?vue&type=style&index=0&id=9cdf578a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cdf578a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VDivider } from 'vuetify/lib/components/VDivider';
installComponents(component, {VCard,VCardText,VChip,VDivider})
